import { CloudProvider, DataGroupListResponse } from '@ariksa/abac/api';

import { SnowflakeIcon } from 'components/index';
import { toTitleCase } from 'utils/string';

export type DataGroupTableRow = DataGroupListResponse & {
  sensitivity_categories?: string[];
};

export interface DataGroupFilters {
  cloud?: string;
  owner?: string;
  sensitivity?: string;
}

export const getDataGroupFiltersFromParams = (
  params: Partial<DataGroupFilters>,
): DataGroupFilters => ({
  cloud: params.cloud,
  owner: params.owner,
  sensitivity: params.sensitivity,
});

export const getDataGroupFilterOptions = (
  rows: DataGroupTableRow[],
  filter: keyof DataGroupFilters,
) => {
  const values = rows.flatMap(row => {
    if (filter === 'cloud') return row.cloud_provider ?? [];
    if (filter === 'owner') return row.owner?.name ?? [];
    return row.sensitivity_categories ?? [];
  });

  return Array.from(new Set(values.filter(Boolean)))
    .sort()
    .map(value => ({
      label: filter === 'sensitivity' ? toTitleCase(value) : value,
      value,
    }));
};

export const filterDataGroupRows = (
  rows: DataGroupTableRow[],
  filters: DataGroupFilters,
) =>
  rows.filter(row => {
    const matchesCloud = !filters.cloud || row.cloud_provider === filters.cloud;
    const matchesOwner =
      !filters.owner ||
      row.owner?.id === filters.owner ||
      row.owner?.name === filters.owner;
    const matchesSensitivity =
      !filters.sensitivity ||
      row.sensitivity_categories?.includes(filters.sensitivity);

    return matchesCloud && matchesOwner && matchesSensitivity;
  });

const dataGroupCloudProviderOptions = [
  {
    label: 'Snowflake',
    value: CloudProvider.Snowflake,
    icon: <SnowflakeIcon />,
  },
];
